<template>
  <div class="body-material-table">
    <template v-if="isWoollen === true">
      <div
        class="body-material-cailiao-1"
        v-for="(item, $index) in info.fabricList"
        :key="`body-material-table__list-${$index}`"
      >
        <div class="body-material-cailiao-1__row">
          <div>面料名称</div>
          <div>针数</div>
          <div>纱支规格</div>
          <div>成品重量</div>
        </div>
        <div class="body-material-cailiao-1__row">
          <div>{{item.fabricName}}</div>
          <div>{{item.needles}}</div>
          <div>{{item.spec}}</div>
          <div>{{item.weight}}</div>
        </div>
        <div
          class="body-material-cailiao-1__less"
          :class="`index-${$index === info.fabricList.length - 1?'isLast':null}`"
        >
          <div>成分</div>
          <div>{{item.component}}</div>
        </div>
      </div>
    </template>

    <template v-else>
      <table class="body-material-table">
        <tr class="body-material-table__tr">
          <th>面料名称</th>
          <th>幅宽/M</th>
          <th>单件用量(M)</th>
          <th>成分</th>
        </tr>
        <tr
          class="body-material-table__tr"
          v-for="(item, $index) in info.fabricList"
          :key="`body-material-table__list-${$index}`"
        >
          <td>{{item.fabricName}}</td>
          <td>{{item.breadth}}</td>
          <td>{{item.singleDosage}}</td>
          <td>{{item.component}}</td>
        </tr>
      </table>
    </template>
  </div>
</template>

<script>
import { formatImgUrl } from "src/filter/modules/img";

export default {
  name: "print-cailiao",
  filters: {
    formatImgUrl,
    formatCodeList(array, keys) {
      return array
        .reduce((pre, next) => {
          const index = keys.findIndex(inner => inner.colorCode == next);
          if (index > -1) pre.push(keys[index].colorName);
          return pre;
        }, [])
        .join(",");
    },
    filterSizeName(obj) {
      const { sizeCode, sizeName } = obj;
      const str = sizeName.match(/[a-zA-Z]+/);
      if (sizeCode == "pieceSize" || sizeCode == "codeSize") return sizeName;
      if (!str) return sizeName;
      return str[0];
    },
    formatString(str) {
      if (!str) return "";
      return str.replace(/\s*/g, "");
    }
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    isWoollen: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "src/sass/index";
@import "src/sass/modules/mixin";
$_normal_font: 4mm;
$_title_font: 5mm;
$box_width: 190mm;
$box_height: 277mm;
$_black: #333;
.default_text_over {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 7;
  overflow: hidden;
}
.default_border {
  border-top: 1px solid $_black;
  border-left: 1px solid $_black;
}
.default_title {
  height: 6mm;
  text-align: center;
}
.default_table {
  width: 100%;
  td {
    border-collapse: collapse;
  }
  td,
  th {
    border: 1px solid $_black;
    border: 1px solid $_black;
  }
}
// 面料详情
.body-material-table {
  @extend .default_table;
  width: 100%;
  .body-material-table__tr {
    height: 6.8mm;
  }
}
.body-material-cailiao-1 {
  .body-material-cailiao-1__row,
  .body-material-cailiao-1__less {
    & > div {
      border-top: 1px solid $_black;
      border-left: 1px solid $_black;
    }
    height: 6.2mm;
    overflow: hidden;
  }
  .body-material-cailiao-1__row {
    @include grid_template(40% 20% 20% 20%, 100%);
  }

  .body-material-cailiao-1__less {
    @include grid_template(40% 60%, 100%);
    &.index-isLast > div {
      border-bottom: 1px solid $_black;
    }
  }
}
</style>
